module.exports = __webpack_public_path__ + "static/media/logo-intelipost.ecca4086.svg";